import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Lock } from '@phosphor-icons/react';

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1c1917] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-white tracking-tight" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Quotent
          </h1>
          <p className="text-[11px] text-stone-500 mt-1 uppercase tracking-[0.15em] font-medium">Quotation System</p>
        </div>

        <div className="bg-white border border-stone-200 p-8">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={18} className="text-[#002FA7]" weight="bold" />
            <h2 className="text-sm font-bold text-stone-900 uppercase tracking-wider">Sign In</h2>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-xs font-medium" data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wider text-stone-500 mb-1.5">Username</label>
              <input
                data-testid="login-username"
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                className="w-full text-sm border border-stone-200 bg-stone-50 px-3 py-2.5 focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none transition-all"
                placeholder="Enter username"
                required
                autoFocus
              />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wider text-stone-500 mb-1.5">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full text-sm border border-stone-200 bg-stone-50 px-3 py-2.5 focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none transition-all"
                placeholder="Enter password"
                required
              />
            </div>
            <button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full py-2.5 text-sm font-semibold text-white bg-[#002FA7] hover:bg-[#002480] transition-all active:scale-[0.98] disabled:opacity-50"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p className="text-center text-[10px] text-stone-600 mt-6">
          Contact your administrator for login credentials
        </p>
      </div>
    </div>
  );
}
